const FORMAT_SIZE_IN_MM = {
  "A4-portrait": {
    height: 297,
    width: 210
  },
  "A4-landscape": {
    height: 210,
    width: 297
  }
};

export { FORMAT_SIZE_IN_MM };
//# sourceMappingURL=constants.js.map
